import { render, staticRenderFns } from "./SupervisorDashboard4.vue?vue&type=template&id=3ff3cdb6&scoped=true&"
import script from "./SupervisorDashboard4.vue?vue&type=script&lang=js&"
export * from "./SupervisorDashboard4.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorDashboard4.vue?vue&type=style&index=0&id=3ff3cdb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff3cdb6",
  null
  
)

export default component.exports